<backbone>
  <section header-page="topbar" class="d-flex justify-content-between gap-2 h-100 position-relative">
    <div class="d-flex justify-content-start align-items-center text-truncate">
      <p class="m-0 fw-medium text-truncate">Historial de cambios en la plataforma.</p>
    </div>

    <div class="d-flex justify-content-end align-items-center gap-3">
      <breadcrumb [items]="[{ label: 'App' }, { label: 'Historial de cambios en la plataforma.' }]" />
    </div>
  </section>

  <section wrapper>
    <p-tabView [activeIndex]="0">
      <p-tabPanel tabindex="0" header="Aragorn - Frontend (Angular 19)">
        <div class="page-section card">
          <div class="card-body p-0">
            <div class="markdown-body" [innerHTML]="changelogAragorn"></div>
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel tabindex="1" header="Sauron - API (PHP 8.0)">
        <div class="page-section card">
          <div class="card-body p-0">
            <div class="markdown-body" [innerHTML]="changelogSauron"></div>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </section>
</backbone>
